
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
/* eslint-disable prettier/prettier */
import React from "react";
import useTranslation from "next-translate/useTranslation";
import Trans from "next-translate/Trans";

import { Head } from "@/components/Head";
import { useTheme } from "@/hooks/useTheme";
import { Converter } from "@/containers/Converter";

import { MagicianSection } from "@/sections/MagicianSection";
import { TrustedBySection } from "@/sections/TrustedBySection";
import { SelectFormatSection } from "@/sections/SelectFormatSection";
import { ApiTeaserSection } from "@/sections/ApiTeaserSection";
import { CTASection } from "@/sections/CTASection";
import { ShareDesignSection } from "@/sections/ShareDesignSection";
import { ConversionSection } from "@/sections/ConversionSection";
import { CustomersLogosSection } from "@/sections/CustomersLogosSection";

const PSDToCanva = () => {
  const { t } = useTranslation();
  const { colors } = useTheme();

  return (
    <>
      <Head
        pageNamespace="page/PSDToCanva"
        ogImage="/images/psd2canva-og-image.jpg"
      />

      <MagicianSection
        title={t("page/PSDToCanva:title")}
        subtitle={t("page/PSDToCanva:subtitle")}
        magicianLogoFile="psd"
        showStartsAt={true}
      >
        <Converter disabled />
      </MagicianSection>

      <TrustedBySection />

      <ApiTeaserSection
        title={
          ((
            <Trans
              i18nKey="page/PSDToCanva:section/apiTeaser.title"
              components={[<span style={{ color: colors.ORANGE }} key={0} />]}
            />
          ) as unknown) as string
        }
        backgroundColor="#fffffe"
        cta={{
          title: t("common:actions.doNow", { do: t("common:actions.convert") }),
        }}
        elements={t(
          "page/PSDToCanva:section/apiTeaser.apiTeaserElements",
          null,
          {
            returnObjects: true,
          },
        )}
        image={{
          src: "/images/psd-to-canva-example.png",
          alt: "PSD to Canva Example",
        }}
      />

      <ShareDesignSection
        id="ShareDesignSection"
        title={
          ((
            <Trans
              i18nKey="page/PSDToCanva:section/shareDesign.title"
              components={[<span key="0" style={{ color: colors.ORANGE }} />]}
            />
          ) as unknown) as string
        }
        image={{
          src: "/images/psd-to-canva-converted-file-elements.jpg",
          alt: t("page/PSDToCanva:section/shareDesign.imageAlt"),
        }}
        backgroundColor={colors.LIGHT_GRAY1}
        cta={{
          title: t("page/PSDToCanva:section/shareDesign.ctaButton"),
        }}
        elements={[
          {
            id: "ELEMENT#1",
            iconType: "SPREAD-ICON",
            title: t(
              "page/PSDToCanva:section/shareDesign.elements.pathElementsTitle",
            ),
            text: t(
              "page/PSDToCanva:section/shareDesign.elements.pathElementsText",
            ),
          },
          {
            id: "ELEMENT#2",
            iconType: "FOLDER-SIMPLE-ICON",
            title: t(
              "page/PSDToCanva:section/shareDesign.elements.folderStructureTitle",
            ),
            text: t(
              "page/PSDToCanva:section/shareDesign.elements.folderStructureText",
            ),
          },
          {
            id: "ELEMENT#3",
            iconType: "CHECK-ICON-EMPTY",
            title: t(
              "page/PSDToCanva:section/shareDesign.elements.folderAccurateTitle",
            ),
            text: t(
              "page/PSDToCanva:section/shareDesign.elements.folderAccurateText",
            ),
          },
        ]}
      />

      <ConversionSection
        title={t("page/PSDToCanva:section/conversion.title")}
        iconBadges={[
          {
            iconType: "SHEETS",
            text: t("page/PSDToCanva:section/conversion.badges.supportsAll"),
          },
          {
            iconType: "SYNC-ICON",
            text: t("page/PSDToCanva:section/conversion.badges.stickyNotes"),
          },
          {
            iconType: "CHECK-ICON-EMPTY",
            text: t("page/PSDToCanva:section/conversion.badges.connectors"),
          },
        ]}
        elements={{
          from: {
            iconType: "PHOTOSHOP",
            image: "/images/psd-canva-preview.jpg",
            title: "PSD Demo Preview",
          },
          to: {
            iconType: "AI",
            image: "/images/psd-canva-preview-second.jpg",
            title: "Canva Demo Preview",
          },
        }}
      />

      <CustomersLogosSection />

      <SelectFormatSection title={t("section/selectFormat:title")} />

      <CTASection
        title={t("section/cta:titles.psdToCanvaPage")}
        href="#upload"
      />
    </>
  );
};

// Temporal workaround for https://github.com/vercel/next.js/discussions/18396
 async function _getStaticProps() {
  return {
    props: {},
  };
}

export default PSDToCanva;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/converter/psd-to-canva',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  